export class ContactDataConsts {
    static EMAIL = 'email';
    static PHONE_NUMBER = 'phoneNumber';
}
